import { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Box, Text, Group } from '@mantine/core';
import { IconFileText } from '@tabler/icons-react';

function PageNode({ data, selected }: NodeProps) {
  return (
    <Box
      style={{
        background: 'white',
        border: `2px solid ${selected ? '#6366f1' : '#e5e7eb'}`,
        borderRadius: '8px',
        padding: '12px 16px',
        minWidth: '200px',
        boxShadow: selected ? '0 4px 12px rgba(99, 102, 241, 0.3)' : '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Handle type="target" position={Position.Top} />
      <Group gap="xs" wrap="nowrap">
        <Box
          style={{
            background: '#6366f1',
            borderRadius: '6px',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconFileText size={18} color="white" />
        </Box>
        <Box style={{ flex: 1 }}>
          <Text size="xs" c="dimmed" fw={500}>
            PAGE
          </Text>
          <Text size="sm" fw={600} lineClamp={1}>
            {data.title || 'Untitled Page'}
          </Text>
        </Box>
      </Group>
      <Handle type="source" position={Position.Bottom} />
    </Box>
  );
}

export default memo(PageNode);
